import { ComponentPropsWithoutRef } from 'react';

export interface SkipLinkProps extends ComponentPropsWithoutRef<'a'> {
  /** ID of the main content, without the leading `#`. */
  targetId?: string;
}

/**
 * Skip link to the main content. Only visible while it has keyboard focus — required by
 * BITV 2.0 / WCAG 2.4.1.
 */
export const SkipLink = ({
  targetId = 'inhalt',
  children = 'Zum Inhalt springen',
  className,
  ...props
}: SkipLinkProps) => (
  <a
    {...props}
    href={`#${targetId}`}
    className={['kern-link', 'vf-skip-link', className]
      .filter(Boolean)
      .join(' ')}
  >
    {children}
  </a>
);
